export default class surveyList {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                subscribers: '=',
                loading: '='
            },
            template: require('../../../../views/event/directives/survey-list.html'),
            replace: true,
            controller: function($scope) {
                this._scope = $scope;

                this._scope.$watch(() => $scope.subscribers, (subscribers) => {
                    this.subscribers = subscribers;
                });

                this._scope.$watch(() => $scope.loading, (loading) => {
                    this.loading = loading;
                });

                this.showSubscriberEventData = (event, subscriber) => {
                    event.stopPropagation();
                    this._scope.$emit('event:subscriber:showData', subscriber);
                };
            },
            controllerAs: 'ctrl'
        };
    }
};